import t from "react";
const o = t.createContext({});
export {
  o as Context
};
//# sourceMappingURL=context.js.map
